import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'
import { OrgTypeEnumSchema } from '../../org/models/OrgTypeEnum'
import validationConstants from '@gap/utils/validation/validation-constants'
import { RoleName } from './RoleDto'

export const RoleEntityDtoSchema = z.object({
   id: z.string({ errorMap }),
   name: z.string({ errorMap }).min(1).max(validationConstants.maxRoleNameLength) as z.ZodType<RoleName>,
   description: z.string({ errorMap }).optional(),
   orgType: OrgTypeEnumSchema,
   lastUpdatedAt: z.string({ errorMap }),
   lastUpdatedBy: z.string({ errorMap }),
   displayOrder: z.number({ errorMap }),
})
